import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useController, useFormContext, } from 'react-hook-form';
import { useCallback, useMemo, forwardRef, } from 'preact/compat';
import { DummyLink } from '@genericBookings/components/SelectedOption/styles';
function TermsCheckbox(props) {
    const { name: fieldName, onLinkClicked } = props;
    const { control, setValue, trigger } = useFormContext();
    const { field: { value: fieldValue }, } = useController({
        name: fieldName,
        control,
    });
    const handleChange = useCallback((ev) => {
        // Uses setValue to "touch" the field, onChange from the useController Doesn't seem to do it
        setValue(fieldName, ev.currentTarget.checked, { shouldTouch: true, shouldValidate: true });
        trigger(fieldName);
    }, [setValue, fieldName, trigger]);
    // useId() was returning the same unique id for the different instances of the form ... no idea - LT
    const formKey = useMemo(() => Math.floor(Math.random() * Math.floor(Math.random() * Date.now())), []);
    return (_jsxs("div", { className: "checkbox checkbox--terms checkout--outline", children: [_jsx("input", { id: `${formKey}-field-${fieldName}`, type: "checkbox", onChange: handleChange, checked: fieldValue, className: "checkbox__input" }), _jsx("label", { htmlFor: `${formKey}-field-${fieldName}`, className: "checkbox__label", children: _jsxs("span", { children: ["I accept the\u00A0", _jsx(DummyLink, { className: "terms-btn", type: "button", onClick: (e) => {
                                e.preventDefault();
                                onLinkClicked();
                            }, children: "terms and conditions" })] }) })] }));
}
export default forwardRef(TermsCheckbox);
